/* eslint-disable @typescript-eslint/no-restricted-imports */

import type { ApolloClient, ApolloLink, RequestHandler } from '@apollo/client/core';

import { useApolloClient as useApolloClientLib } from '@apollo/client';

export * from '@apollo/client';

export { Observable, type ObservableSubscription } from '@apollo/client/utilities';

export const useApolloClient = useApolloClientLib as unknown as (override?: ApolloClient<object>) => (ApolloClient<object> | null);

export type ApolloMiddleware = RequestHandler | ApolloLink
